const unmask = (value) => value;

const masks = {
  none: {
    mask(value) {
      return value;
    },
    unmask(value) {
      return value;
    },
  },

  numberOnly: {
    mask(value, length = 200) {
      if (!value) {
        return "";
      }
      return value.replace(/\D/g, "").substr(0, length);
    },
    unmask: (value) => value.replace(/\D/g, ""),
  },

  name: {
    mask(value) {
      return value.replace(/\d/g, "");
    },
    unmask,
  },

  cpf: {
    mask(cpf) {
      return cpf
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2"); // NOSONAR: executa no front.
    },
    unmask: (cpf) => masks.numberOnly.mask(cpf, 11),
  },

  date: {
    mask(value) {
      return value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1/$2") // NOSONAR: executa no front.
        .replace(/(\d{2})(\d)/, "$1/$2") // NOSONAR: executa no front.
        .substr(0, 10); // NOSONAR: executa no front.
    },
    unmask: (value) => value.substr(0, 10),
  },

  phone: {
    mask(text) {
      const textOnly = text.replace(/\D/g, "");
      const fixoRegex = /(\d{4})(\d{4})/; // NOSONAR: executa no front.
      const mobileRegex = /(\d{5})(\d{4})/; // NOSONAR: executa no front.

      return textOnly
        .replace(/^(\d)/, "($1")
        .replace(/^(\(\d{2})(\d)/, "$1) $2")
        .replace(textOnly.length > 10 ? mobileRegex : fixoRegex, "$1-$2")
        .replace(/(-\d{5})\d+$/, "$1"); // NOSONAR: executa no front.
    },
    unmask: (text) => masks.numberOnly.mask(text, 11),
  },

  cep: {
    mask(cep) {
      if (!cep) {
        return "";
      }
      return cep
        .replace(/\D/g, "")
        .replace(/(.{8})(.)/g, "$1")
        .replace(/^(\d{5})(\d)/, "$1-$2");
    },
    unmask: (cep) => masks.numberOnly.mask(cep, 9),
  },
  maxLength: (length) => ({
    mask(value) {
      return value.substring(0, length);
    },
    unmask: masks.none.unmask,
  }),
};

export default masks;
